<template>
  <zb-tooltip ref="tooltip">
    <template v-slot:trigger="{ toggle }">
      <button class="month-trigger bg-white btn input-tall rounded border border-black-30"
        type="button"
        @click="toggle">
        <div class="flex items-center font-normal">
          <span class="flex-1 text-left pl-1">{{ selectedMonthDisplay }}</span>

          <svg width="24" height="24">
            <use xlink:href="/img/sprite.svg#ic_chevron-down"></use>
          </svg>
        </div>
      </button>
    </template>

    <template>
      <aside class="month-picker bg-white rounded mt-1 p-4 pb-8">
        <header class="flex items-center">
          <div class="flex-none">
            <button class="btn" type="button" @click="goToPrevYear" :disabled="year === minYear">
              <svg width="24" height="24">
                <use xlink:href="/img/sprite.svg#ic_chevron-left"></use>
              </svg>
            </button>
          </div>

          <div class="flex 1 text-center w-full">
            <div class="mx-auto font-medium">
              {{ year }}
            </div>
          </div>

          <div class="flex-none">
            <button class="btn" type="button" @click="goToNextYear" :disabled="year === maxYear">
              <svg width="24" height="24">
                <use xlink:href="/img/sprite.svg#ic_chevron-right"></use>
              </svg>
            </button>
          </div>
        </header>

        <section class="month-grid">
          <div v-for="(month, value) in months" :key="month"
            class="p-2 cursor-pointer"
            :class="{ 'is-disabled': isInThePast(value) }"
            @click="selectMonth(value)">
            {{ month }}
          </div>
        </section>
      </aside>
    </template>
  </zb-tooltip>
</template>

<script>
import Tooltip from '../../components/core/Tooltip.vue'
import {
  MONTHS
} from '../../helpers/constants'
import {
  syncURLParams
} from '../../helpers/searchHelpers'

export default {
  components: {
    'zb-tooltip': Tooltip
  },
  props: ['value'],
  data () {
    const thisYear = moment().year()

    return {
      year: thisYear,
      minYear: thisYear,
      maxYear: thisYear + 2
    }
  },
  computed: {
    months () {
      return MONTHS
    },
    selectedMonthDisplay () {
      return moment(this.value).format('MMMM YYYY')
    }
  },
  methods: {
    goToPrevYear () {
      this.year = this.year - 1
    },
    goToNextYear () {
      this.year = this.year + 1
    },
    isInThePast (monthValue) {
      const today = moment()
      const thisYear = today.year()

      if (this.year < thisYear) {
        return true
      }

      if (this.year > thisYear) {
        return false
      }

      const thisMonth = today.month() + 1
      return monthValue < thisMonth
    },
    selectMonth (monthValue) {
      if (!this.isInThePast(monthValue)) {
        const newMoment = moment(`${this.year}-${monthValue}-01`, 'YYYY-MM-DD').format('YYYY-MM-DD')
      
        this.$emit('input', newMoment)
        this.$refs.tooltip.hide()
      } 
    }
  },
  watch: {
    value (val) {
      const searchParams = new URLSearchParams(window.location.search)
      searchParams.set('from', val)

      syncURLParams(searchParams)
    }
  }
}
</script>

<style scoped>
.month-picker button:disabled {
  opacity: 0.25;
}
</style>
